import React from "react";
import { ProgressSpinner } from 'primereact/progressspinner';
import useWindowDimensions from "./useWindowDimensions";

const SuspenseFallback =() => {
  
    const { height, width } = useWindowDimensions();
    const getStyle = () =>{
      let screenHeight = `${height}px`;
      let screenWidth = `${width}px`;
      return {
        height: screenHeight,
        width: screenWidth
      };
    }
    return (<div style={getStyle()} className="p-grid p-justify-center p-align-center">
      <div className="p-sm-1" style={{justifyContent: 'center' ,alignItems: 'center',display: 'flex'}}>
      <ProgressSpinner style={{width: '50px', height: '50px'}} 
      strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
      </div>
      </div>);
}

export default SuspenseFallback;